<template>
	<v-card>
		<v-card-title class="d-flex align-center">
			<v-icon
				icon="$translate"
				start
			/>
			<translate>The translated URLs</translate>
		</v-card-title>
		<v-card-text>
			<v-data-table
				:headers="headers"
				:items="routesWithTranslations"
				:sort-by="[{key: 'route', localOrder: 'asc'}]"
			/>
		</v-card-text>
	</v-card>
</template>
<script>

export default {
	name: 'TranslatedRouteList',
	props: {
		domainName: {
			type: String,
			required: true
		},
		routesWithTranslations: {
			type: Array,
			required: true,
			default: () => {
				return [];
			}
		}
	},
	computed: {
		/**
		 * @returns {Array}
		 */
		headers: function () {
			return [
				{
					title: this.$gettext('URL'),
					value: 'route'
				},
				{
					title: this.$gettext('Translation'),
					value: 'translation'
				},
			];
		}
	},
};
</script>

<style scoped>

</style>
